<template>
  <div id="app">
    <!-- 移动端菜单 -->
    <div class="mobileMenu" v-if="mobileMenuIsShow">
      <div class="mobile-menu">
        <div class="logo"></div>
        <div class="switch" @click="closeMenuChange">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="menu-content">
        <el-menu
          default-active="2"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          text-color="#334046"
        >
          <el-submenu
            :index="item.index + ''"
            v-for="item in menu"
            :key="item.index"
          >
            <template slot="title">
              <span>{{ item.name }}</span>
            </template>
            <!-- <el-menu-item>111</el-menu-item> -->
            <el-menu-item
              :index="item2.index"
              v-for="item2 in item.children"
              :key="item2.index"
              @click="mobileRouterLink(item2.name)"
            >
              {{ item2.text }}
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
    <!-- /移动端菜单/ -->
    <!-- 主体页面 -->
    <div class="PCcontent" v-else>
      <!-- PC导航 -->
      <div class="nav" v-if="MenuIsShow">
        <div class="logo"></div>
        <div class="menu">
          <ul class="menu-list">
            <li v-for="(item, index) in menu" :key="index">
              <a
                @click="nextChange(item.path)"
                :class="item.path === RouterPath ? 'active' : ''"
                >{{ item.name }}</a
              >
            </li>
          </ul>
        </div>
        <div class="z-btn">
          <a href="http://www.gyycbj.com/jnds/index.html#/Home" target="_blank"
            >Competition</a
          >
        </div>
        <div class="ec-btn">
          <span><a :href="urlCH" target="_self">CN</a></span> |
          <span><a :href="urlEN" target="_self">EN</a></span>
        </div>
      </div>
      <!-- 移动导航 -->
      <div class="mobile-menu" v-else>
        <div class="logo"></div>
        <div class="option">
          <div class="ec-btn">
            <span><a :href="urlCH" target="_self">CN</a></span> |
            <span><a :href="urlEN" target="_self">EN</a></span>
          </div>
          <div class="switch" @click="toMobileChange">
            <i class="el-icon-s-fold"></i>
          </div>
        </div>
      </div>
      <!-- 路由占位符 -->
      <transition enter-active-class="animate__animated animate__fadeIn">
        <router-view />
      </transition>
      <!-- 底部 -->
      <div class="footer">
        <div class="footer-menu">
          <div class="footer-logo">
            <img src="./assets/image/LOGO.webp" alt="" />
          </div>
          <div class="footer-nav">
            <ul class="footer-nav-top">
              <li>
                <p>Service</p>
                <a
                  v-for="(item, index) in footerMenu.Innovate"
                  :key="index"
                  @click="LinkTo(item.name)"
                  >{{ item.text }}</a
                >
              </li>
              <li>
                <p>Industry</p>
                <a
                  v-for="(item, index) in footerMenu.Industry"
                  :key="index"
                  @click="LinkTo(item.name)"
                  >{{ item.text }}</a
                >
              </li>
              <li>
                <p>Commercial</p>
                <a
                  v-for="(item, index) in footerMenu.Business"
                  :key="index"
                  @click="LinkTo(item.name)"
                  >{{ item.text }}</a
                >
              </li>
              <li>
                <p>Medical Training</p>
                <a
                  v-for="(item, index) in footerMenu.Science"
                  :key="index"
                  @click="LinkTo(item.name)"
                  >{{ item.text }}</a
                >
              </li>
              <li>
                <p>Information Platform</p>
                <a
                  v-for="(item, index) in footerMenu.News"
                  :key="index"
                  @click="LinkTo(item.name)"
                  >{{ item.text }}</a
                >
              </li>
              <li>
                <p>Company News</p>
                <a
                  v-for="(item, index) in footerMenu.Trends"
                  :key="index"
                  @click="LinkTo(item.name)"
                  >{{ item.text }}</a
                >
              </li>
              <li>
                <p>About us</p>
                <div class="callmy">
                  <a
                    v-for="(item, index) in footerMenu.About"
                    :key="index"
                    @click="LinkTo(item.name)"
                    >{{ item.text }}</a
                  >
                </div>
              </li>
              <li>
                <p>contact</p>
                <a href="#">
                  <img src="./assets/image/home/167.webp" /> 010-67207401</a
                >
                <a href="#"
                  ><img src="./assets/image/home/168.webp" />
                  lijuan@gytcare.com</a
                >
                <a href="#"
                  ><img src="./assets/image/home/166.webp" /> Room 704, block B,
                  Jiatai building, No. 41, East Fourth Ring Middle Road,
                  Chaoyang District, Beijing</a
                >
                <a
                  >Room 713, block B, Jiatai building, No. 41, East Fourth Ring
                  Middle Road, Chaoyang District, Beijing</a
                >
              </li>
              <li>
                <p>WeChat subscription number</p>
                <div class="ewm"></div>
                <a href="#">【透析专项】</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer-MenuIos">
          <div class="box">
            <div class="top">
              <a @click="LinkTo('home')"
                ><img src="../src/assets/image/LOGO.webp" alt=""
              /></a>
            </div>
          </div>
          <div class="box">
            <div class="top">Service</div>
            <ul class="main">
              <a
                v-for="(item, index) in footerMenu.Innovate"
                :key="index"
                @click="LinkTo(item.name)"
                >{{ item.text }}</a
              >
            </ul>
          </div>
          <div class="box">
            <div class="top">Industry</div>
            <ul class="main">
              <a
                v-for="(item, index) in footerMenu.Industry"
                :key="index"
                @click="LinkTo(item.name)"
                >{{ item.text }}</a
              >
            </ul>
          </div>
          <div class="box">
            <div class="top">Commercial</div>
            <ul class="main">
              <a
                v-for="(item, index) in footerMenu.Business"
                :key="index"
                @click="LinkTo(item.name)"
                >{{ item.text }}</a
              >
            </ul>
          </div>
          <div class="box">
            <div class="top">Medical Training</div>
            <ul class="main">
              <a
                v-for="(item, index) in footerMenu.Science"
                :key="index"
                @click="LinkTo(item.name)"
                >{{ item.text }}</a
              >
            </ul>
          </div>
          <div class="box">
            <div class="top">Information Platform</div>
            <ul class="main">
              <a
                v-for="(item, index) in footerMenu.News"
                :key="index"
                @click="LinkTo(item.name)"
                >{{ item.text }}</a
              >
            </ul>
          </div>
          <div class="box">
            <div class="top">Company News</div>
            <ul class="main">
              <a
                v-for="(item, index) in footerMenu.Trends"
                :key="index"
                @click="LinkTo(item.name)"
                >{{ item.text }}</a
              >
            </ul>
          </div>
          <div class="box">
            <div class="top">About Us</div>
            <ul class="main">
              <a
                v-for="(item, index) in footerMenu.About"
                :key="index"
                @click="LinkTo(item.name)"
                >{{ item.text }}</a
              >
            </ul>
          </div>
          <div class="box2">
            <div class="top">contact</div>
            <ul class="main">
              <li>
                <span>
                  <img src="./assets/image/home/167.webp" /> 010-67207401</span
                >
                <span
                  ><img src="./assets/image/home/168.webp" />
                  lijuan@gytcare.com</span
                >
                <span
                  ><img src="./assets/image/home/166.webp" /> Room 704, block B,
                  Jiatai building, No. 41, East Fourth Ring Middle Road,
                  Chaoyang District, Beijing</span
                >
                <span
                  >Room 713, block B, Jiatai building, No. 41, East Fourth Ring
                  Middle Road, Chaoyang District, Beijing</span
                >
              </li>
            </ul>
          </div>
          <div class="box2">
            <div class="top">WeChat subscription number</div>
            <ul class="main">
              <li>
                <div class="ewm"></div>
                <span>【透析专项】</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer-icp">
          <span
            >Copyright 2022 All Rights Reserved GYT HealthCare Services
            Incorporated</span
          >
          <span
            ><a
              href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
              target="_blank"
              class="beian"
              >京ICP备17004171号-1</a
            ></span
          >
        </div>
      </div>
      <!-- 回到顶部 -->
      <el-backtop :bottom="100">
        <div class="goUp">
          <img src="./assets/image/home/goup.webp" alt="" />
        </div>
      </el-backtop>
    </div>
    <!-- /主体页面/ -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      urlCH: "", // 中文跳转路径
      urlEN: "", // 英文跳转路径
      mobileMenuIsShow: false, //移动端菜单是否显示
      MenuIsShow: true, //PC菜单是否开启
      screenWidth: document.body.clientWidth, //当前屏幕宽度
      menu: [
        {
          name: "Home",
          path: "home",
          index: 1,
          children: [],
        },
        {
          name: "Service",
          path: "Innovate",
          index: 2,
          children: [
            {
              name: "jiceng",
              text: "Work with primary-level governments",
              index: "2-1",
            },
            {
              name: "touxi",
              text: "Setting up of Hemodialysis Unit",
              index: "2-2",
            },
            {
              name: "doctorIP",
              text: "self-media brands operation",
              index: "2-3",
            },
            {
              name: "kexue",
              text: "Advertisement of hospital departments",
              index: "2-4",
            },
            {
              name: "shuzi",
              text: "Digital Marketing",
              index: "2-5",
            },
            {
              name: "yidi",
              text: "Remote Hemodialysis",
              index: "2-6",
            },
          ],
        },
        {
          name: "Industry",
          path: "Industry",
          index: 3,
          children: [
            {
              name: "kaineng",
              text: "Kangdewei",
              index: "3-1",
            },
            {
              name: "water",
              text: "Hemodialysis Water Treatment Equipment",
              index: "3-2",
            },
            {
              name: "jizhong",
              text: "Dialysis Centralized Liquid Supply System",
              index: "3-3",
            },
          ],
        },
        {
          name: "Commercial ",
          path: "Business",
          index: 4,
          children: [],
        },
        {
          name: "Medical Training",
          path: "Science",
          index: 5,
          children: [
            {
              name: "zhuanxiang",
              text: "Special Training",
              index: "5-1",
            },
            {
              name: "jiaoxue",
              index: "5-2",
              text: "Live Teaching",
            },
            {
              name: "xueshu",
              index: "5-3",
              text: "Academic Promotion",
            },
            {
              name: "jineng",
              index: "5-4",
              text: "Competition",
            },
            {
              name: "bingli",
              index: "5-5",
              text: "Cases Collection",
            },
          ],
        },
        {
          name: "Information Platform",
          path: "News",
          index: 6,
          children: [
            {
              name: "keshigl",
              text: "Department Management System",
              index: "6-1",
            },
            {
              name: "watergl",
              text: "Dialysis Water Treatment System",
              index: "6-2",
            },
            {
              name: "huanzhegl",
              text: "Patient Management System",
              index: "6-3",
            },
          ],
        },
        {
          name: "Company News",
          path: "Trends",
          index: 7,
          children: [],
        },
        {
          name: "About Us",
          path: "About",
          index: 8,
          children: [
            {
              name: "fazhan",
              text: "The GYT Timeline",
              index: "8-1",
            },
            {
              name: "rencai",
              text: "Talent recruitment",
              index: "8-2",
            },
          ],
        },
      ],
      RouterPath: "home",
      footerMenu: {
        // 创新服务
        Innovate: [
          {
            name: "jiceng",
            text: "Work with primary-level governments",
          },
          {
            name: "touxi",
            text: "Setting up of Hemodialysis Unit",
          },
          {
            name: "doctorIP",
            text: "'self-media' brands operation",
          },
          {
            name: "kexue",
            text: "Advertisement of hospital departments",
          },
          {
            name: "shuzi",
            text: "Digital Marketing",
          },
          {
            name: "yidi",
            text: "Remote Hemodialysis",
          },
        ],
        // 工业生产
        Industry: [
          {
            name: "kaineng",
            text: "Kang De Wei",
          },
          {
            name: "kaineng",
            text: "Hemodialysis Water Treatment Equipment",
          },
          {
            name: "jizhong",
            text: "Dialysis Centralized Liquid Supply System",
          },
        ],
        // 商业渠道
        Business: [
          {
            name: "Business",
            text: "Business Network",
          },
        ],
        // 医学培训
        Science: [
          {
            name: "zhuanxiang",
            text: "Special Training",
          },
          {
            name: "jiaoxue",
            text: "Live Teaching",
          },
          {
            name: "xueshu",
            text: "Academic Promotion",
          },
          {
            name: "jineng",
            text: "Competition",
          },
          {
            name: "bingli",
            text: "Cases Collection",
          },
        ],
        // 信息平台
        News: [
          {
            name: "keshigl",
            text: "Department management",
          },
          {
            name: "watergl",
            text: "Water treatment system",
          },
          {
            name: "huanzhegl",
            text: "patient Administration",
          },
        ],
        // 公司动态
        Trends: [
          {
            name: "Trends",
            text: "Latest News",
          },
        ],
        //关于我们
        About: [
          {
            name: "fazhan",
            text: "The GYT Timeline ",
          },
          {
            name: "rencai",
            text: " Career",
          },
        ],
      },
    };
  },
  created() {
    if (this.screenWidth < 540) {
      this.MenuIsShow = false;
    }
    if (window.location.href.split("/")[2] == "testwww.gytcare.com") {
      this.urlCH = "http://testwww.gytcare.com/#/home";
      this.urlEN = "http://testwww.gytcare.com/en/#/home";
    } else if (window.location.href.split("/")[2] == "www.gytcare.com") {
      this.urlCH = "http://www.gytcare.com/#/home";
      this.urlEN = "http://www.gytcare.com/en/#/home";
    } else {
      this.urlCH = "#";
      this.urlEN = "#";
    }
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  },
  watch: {
    screenWidth() {
      if (this.screenWidth <= 540) {
        this.MenuIsShow = false;
      } else {
        this.MenuIsShow = true;
      }
    },
    $route(to) {
      this.mobileMenuIsShow = false;
      let newpath = to.path.slice(1).split("/")[0];
      // console.log(newpath);
      this.RouterPath = newpath;
    },
  },
  methods: {
    // 二级跳转
    mobileRouterLink(name) {
      this.$router.push({ name });
      this.mobileMenuIsShow = false;
    },
    // 关闭导航栏
    closeMenuChange() {
      this.mobileMenuIsShow = false;
    },
    // 移动端一级导航打开关闭
    handleOpen(key) {
      if (key == 1) {
        this.$router.push({ name: "home" }).catch((err) => err);
        this.mobileMenuIsShow = false;
      } else if (key == 4) {
        this.$router.push({ name: "Business" }).catch((err) => err);
        this.mobileMenuIsShow = false;
      } else if (key == 7) {
        this.$router.push({ name: "Trends" }).catch((err) => err);
        this.mobileMenuIsShow = false;
      }
    },
    handleClose() {},
    //
    toMobileChange() {
      this.mobileMenuIsShow = true;
    },
    nextChange(path) {
      this.$router.push({ name: path });
      // this.RouterPath = path
    },
    LinkTo(name) {
      this.$router.push({ name: name });
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style lang="scss">
#app {
  // width: 100vw;
  .nav {
    height: 1.0638rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .logo {
      width: 1rem;
      height: 0.5957rem;
      background: url("./assets/image/LOGO.webp") no-repeat;
      background-size: 100% 100%;
    }
    .active {
      color: #0ca6eb !important;
      padding-bottom: 0.1277rem;
      border-bottom: 0.0319rem solid #0ca6eb;
      border-radius: 0.0106rem;
    }
    .menu {
      .menu-list {
        padding: 0 0.1979rem;
        display: flex;
        li {
          list-style: none;
          padding: 0 0.1979rem;
          a {
            color: #000000;
            cursor: pointer;
            font-size: 0.1915rem;
            font-weight: 700;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-family: Source Han Sans CN;
          }
        }
      }
    }
    .z-btn {
      height: 0.5319rem;
      width: 1.7021rem;
      background: #1ebaff;
      text-align: center;
      line-height: 0.5319rem;
      font-size: 0.1915rem;
      border-radius: 3px;
      cursor: pointer;
      margin-right: 0.383rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-left: 0.6383rem;
      a {
        width: 100%;
        height: 100%;
        display: block;
        color: #fff;
        list-style: none;
      }
    }
    .ec-btn {
      text-align: center;
      font-size: 0.1915rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      span {
        padding: 0 0.1915rem;
        cursor: pointer;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        a {
          color: #000;
        }
      }
    }
  }
  // 移动端导航内容
  .mobileMenu {
    .menu-content {
      background-color: #fff;
      .el-menu {
        border-right: none;
        .el-submenu__title {
          font-size: 16px;
          border-bottom: 1px solid #eaeaea;
          box-sizing: border-box;
          padding: 0 !important;
          margin: 0 20px;
        }
        .el-submenu__title:hover {
          background-color: #fff;
        }
        .el-menu-item {
          color: #a2a2a2 !important;
        }
      }
    }
  }
  // 移动端导航
  .mobile-menu {
    height: 60px;
    background-color: #fff;
    display: flex;
    align-items: center;
    padding: 0 15px;
    justify-content: space-between;
    .logo {
      height: 40px;
      width: 70px;
      background: url("./assets/image/LOGO.webp") no-repeat;
      background-size: 100%;
    }
    .option {
      display: flex;
      align-items: center;
      .ec-btn {
        padding: 0 20px;
        text-align: center;
        font-size: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        span {
          padding: 0 0.1915rem;
          cursor: pointer;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          a {
            color: #000000;
          }
        }
      }
      .switch {
        i {
          color: #898989;
          font-size: 30px;
        }
      }
    }
  }
  // 底部
  .footer {
    .footer-MenuIos {
      display: none;
      padding: 20px 0;
      @media screen and (max-width: 540px) {
        display: flex;
        flex-wrap: wrap;
      }
      .box {
        flex-basis: 23%;
        box-sizing: border-box;
        flex-shrink: 0;
        .top {
          padding: 0 10px;
          text-align: left;
          height: 50px;
          color: #2b2b2b;
          font-size: 13px;
          overflow: hidden;
          line-height: 50px;
          border-bottom: 1px solid #dbdbdb;
          img {
            width: 57px;
            height: 25px;
            margin-top: 10px;
          }
        }
        .main {
          padding: 0 10px;
          padding-bottom: 27px;
          a {
            color: #9f9f9f;
            overflow: hidden;
            text-align: left;
            display: block;
            padding-top: 14px;
          }
        }
      }
      .box2 {
        flex-basis: 50%;
        box-sizing: border-box;
        flex-shrink: 0;
        .top {
          padding: 0 15px;
          text-align: left;
          height: 50px;
          color: #2b2b2b;
          font-size: 15px;
          line-height: 50px;
          border-bottom: 1px solid #dbdbdb;
          img {
            width: 57px;
            height: 25px;
            margin-top: 10px;
          }
        }
        .main {
          padding: 0 15px;
          padding-bottom: 27px;
          .ewm {
            margin-top: 10px;
            width: 75px;
            height: 75px;
            background: url("./assets/image/home/ewm.webp") no-repeat;
            background-size: 100% 100%;
          }
          a {
            color: #9f9f9f;
            padding-top: 14px;
            display: block;
          }
          span {
            display: block;
            padding-top: 14px;
            color: #9f9f9f;
            overflow: hidden;
            padding-top: 14px;
          }
        }
      }
    }
    .footer-menu {
      // height: 3.6842rem;
      @media screen and (max-width: 540px) {
        display: none;
      }
      padding: 0 1.6842rem;
      margin-bottom: 0.4842rem;
      justify-content: space-between;
      display: flex;
      .footer-logo {
        width: 1.0526rem;
        height: 0.5895rem;
        padding-right: 0.2632rem;
        padding-top: 0.4rem;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .footer-nav {
        width: 100%;
        .footer-nav-top {
          margin: 0;
          // height: 3.6842rem;
          overflow: hidden;
          display: flex;
          position: relative;
          li {
            // float: left;
            padding: 0 0.1547rem;
            font-size: 0.1684rem;
            width: 122px;
            color: #2b2b2b;
            p {
              padding: 0.4rem 0 0.4421rem 0;
              // border-bottom: 1px solid #dbdbdb;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            a {
              font-size: 0.1474rem;
              color: #9f9f9f;
              cursor: pointer;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: left;
              display: block;
              padding: 0.0842rem 0;
              img {
                margin-right: 0.0526rem;
              }
            }
            .callmy {
              border-right: 1px solid #dbdbdb;
              padding-right: 0.2421rem;
              height: 2.1053rem;
            }
          }

          li:nth-child(8) {
            padding: 0 0 0 0.5316rem;
            // box-sizing: border-box;
            width: 2.2105rem;
            a {
              white-space: initial;
            }
          }
          .ewm {
            width: 1.0526rem;
            height: 1.0526rem;
            background: url("./assets/image/home/ewm.webp") no-repeat;
            background-size: 100% 100%;
          }
        }
        .footer-nav-top::after {
          position: absolute;
          content: "";
          top: 0.8421rem;
          left: 0;
          width: 100%;
          height: 1px;
          background-color: #eeeeee;
        }
      }
    }
    .footer-icp {
      height: 0.6383rem;
      background-color: #d4d4d4;
      line-height: 0.6383rem;
      padding: 0 1.7021rem;
      text-align: left;
      font-size: 0.1489rem;
      color: #666666;
      display: flex;
      justify-content: space-between;
      .beian {
        color: #666;
      }
      .beian:hover {
        color: #333;
        cursor: pointer;
      }
      @media screen and (max-width: 540px) {
        height: 100%;
        display: block;
        font-size: 12px;
        padding: 16px 0 0 15px;
        span {
          display: block;
          padding-bottom: 16px;
        }
      }
    }
  }
  // 回到顶部
  .el-backtop {
    border-radius: 0;
    width: 0.6316rem;
    height: 0.6316rem;
    background-color: #fff0;
    @media screen and (max-width: 540px) {
      height: 1.8947rem;
      width: 1.8947rem;
    }
  }
  .goUp {
    height: 100%;
    width: 100% !important;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0ca6eb;
    // box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
    z-index: 999;
    color: #fff;
    border-radius: 0.0526rem;
    img {
      width: 0.2105rem;
      height: 0.2526rem;
      @media screen and (max-width: 540px) {
        height: 1.0526rem;
        width: 1.0526rem;
      }
    }
  }
}
</style>
